import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Icon from "./Icons";

// Locks page scroll while an overlay is open (nested overlays count).
let locks = 0;
export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    locks += 1;
    const html = document.documentElement;
    const prev = html.style.overflow;
    html.style.overflow = "hidden";
    return () => {
      locks -= 1;
      if (!locks) html.style.overflow = prev;
    };
  }, [active]);
}

// Side drawer on desktop, bottom sheet on phones (the CSS decides).
export default function Sheet({ open, onClose, title, badge, children, footer, side = "right", className = "" }) {
  const panel = useRef(null);
  useScrollLock(open);
  useEffect(() => {
    if (!open) return undefined;
    const back = document.activeElement;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    setTimeout(() => panel.current?.focus(), 30);
    return () => {
      document.removeEventListener("keydown", onKey);
      back?.focus?.();
    };
  }, [open, onClose]);
  if (!open) return null;
  return createPortal(
    <div className="sh-sheet-root" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`sh-sheet sh-sheet-${side} ${className}`} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={panel}>
        <header className="sh-sheet-head">
          <h2>
            {title}
            {badge ? <span className="sh-fp-head-count">{badge}</span> : null}
          </h2>
          <button className="sh-iconbtn" onClick={onClose} aria-label="Close">
            <Icon name="close" />
          </button>
        </header>
        <div className="sh-sheet-body">{children}</div>
        {footer && <footer className="sh-sheet-foot">{footer}</footer>}
      </div>
    </div>,
    document.body
  );
}
